var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',{staticStyle:{"padding-inline-start":"calc(15px + 1rem + 4px)"},attrs:{"to":{ name: 'service', params: { serviceId: _vm.service.serviceId } }}},[_c('v-list-item-content',[_c('v-list-item-title',{domProps:{"textContent":_vm._s(_vm.service.nom)}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }